import React from "react";
import Topbar from "../components/Topbar";
import Logobar from "../components/Logobar";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import About from "../components/About";
import Collections from "../components/Collections";
import WhyChooseUs from "../components/WhyChooseUs";
import Testimonials from "../components/Testimonials";
import Footer from "../components/Footer";
import GifSection from "../components/GifSection";
import ContactSection from "../components/ContactSection";
import Image from "../components/Image";


function LandingPage() {
  return (
    <>
      <Topbar />
      <Logobar />
      <Navbar />
      <Hero />
      <About />
      <Image/>
      <Collections />
      <GifSection />
      <WhyChooseUs />
      <ContactSection/>
      <Testimonials />
      <Footer />
    </>
  );
}

export default LandingPage;
